import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { ProductType } from "../../../apis/networkdashboard/graphql/graphql";
import { ServiceSpeedPipe } from "../../../helpers/service-speed-pipe/service-speed-pipe";
import { serviceHealth } from "../../dashboard/service-health-signal/service-health-signal";
import { ServiceTitleBlock } from "../service-title-block/service-title-block";

export interface ServiceType {
  subscriptionId: string;
  customerDescription?: string | null;
  organisation?: string | null;
  portSpeed?: number | null;
  product: ProductType;
  patchPosition?: string | null;
  ieeeInterfaceType?: string | null;
  tags: string[];
}

@Component({
  selector: "port-tile",
  templateUrl: "port-tile.html",
  styleUrls: ["../port-visualiser/port-visualiser.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, ServiceSpeedPipe, ServiceTitleBlock],
})
export class PortTile {
  protected service = input.required<ServiceType>();
  protected health = serviceHealth(this.service);

  protected customerDescription = computed(() => this.service().customerDescription ?? "");

  protected portSpeed = computed(() => this.service().portSpeed);
  protected patchPosition = computed(() => this.service().patchPosition);
  protected interfaceType = computed(() => this.service().ieeeInterfaceType);
}
